import "./App.css";
import Navigation from "./Component/Navigation";
import Card from "./Component/Card";
import ChartCard from "./Component/ChartCard";
import ChartTop from "./Component/ChartTop";
import SideCard from "./Component/SideCard";
import Chartb from "./Component/Chartb";
import MyTable from "./Component/Table_customer";
import Heade from "./Component/Heade";

const navbrand = ["OneUI Vue"];
const navname = ["img/parth.jpg", "Parth"];
const navdata = [
  "Dashboard",
  "page packs",
  "USER INTERFACE",
  "Blocks",
  "Elements",
  "Tables",
  "Forms",
  "DEVELOP",
  "plugins",
  "Layout",
  "Multi level Menu",
  "PAGES",
  "Generic",
  "Authentication",
  "Error Pages",
];

const cardContent = {
  heading: ["32", "124", "45", "4.5%"],
  icons: [
    <i className="fa-solid fa-users fa-2xl text-light"></i>,
    <i className="fa-solid fa-link fa-2xl text-light"></i>,
    <i className="fa-solid fa-comment fa-2xl text-light"></i>,
    <i className="fa-solid fa-link fa-2xl text-light"></i>,
  ],
  subheading: [
    "Pending Orders",
    "New Customers",
    "Messages",
    "Conversion Rate",
  ],
  subofheading: [
    "View all orders",
    "View all customers",
    "View all messages",
    "View statistics",
  ],
};

const contenttop = ["EARNINGS SUMMARY"];
const contenttopw = [<i className="fa-solid fa-gear"></i>];
const cardBottom = {
  headings: ["2.5% ", "3.8% ", "1.7%"],
  subheadings: ["Customer Growth", "Page Views", "New Products"],
  icons: [
    <i className="fa-solid fa-caret-down"></i>,
    <i className="fa-solid fa-caret-down"></i>,
    <i className="fa-solid fa-caret-down"></i>,
  ],
};
const divcardContent = {
  headings: ["570", "$5,234.21", "264"],
  subheading: ["Total Orders", "Total Earnings", "New Customers"],
  icons: [
    <i className="fa-solid fa-caret-down"></i>,
    <i className="fa-solid fa-caret-down"></i>,
    <i className="fa-solid fa-caret-down"></i>,
  ],
  number: [" 2.2%", "4.2%", "9.3%"],
};

const divfooter = ["OneUI Vue Edition 2.2.0 © 2022"];
const divder = ["Crafted with  by Vaishz"];

function App() {
  return (
    <div className="container justify-content-between">
      <div className="">
        <Navigation
          navheading={navbrand[0]}
          navphoto={navname[0]}
          navphoto1={navname[1]}
          navitem1={navdata[0]}
          navitem2={navdata[1]}
          navitem3={navdata[2]}
          navitem4={navdata[3]}
          navitem5={navdata[4]}
          navitem6={navdata[5]}
          navitem7={navdata[6]}
          navitem8={navdata[7]}
          navitem9={navdata[8]}
          navitem10={navdata[9]}
          navitem11={navdata[10]}
          navitem12={navdata[11]}
          navitem13={navdata[12]}
          navitem14={navdata[13]}
          navitem15={navdata[14]}
        />
      </div>

      <div className=" container row gy-3 mx-auto mt-5">
        <div className="col-md-6 col-lg-3 gy-3">
          <Card
            head={cardContent.heading[0]}
            subhead={cardContent.subheading[0]}
            chartIcons={cardContent.icons[0]}
            suboffheading={cardContent.subofheading[0]}
          ></Card>
        </div>
        <div className="col-md-6 col-lg-3">
          <Card
            head1={cardContent.heading[1]}
            subhead1={cardContent.subheading[1]}
            chartIcons1={cardContent.icons[1]}
            suboffheading1={cardContent.subofheading[1]}
          ></Card>
        </div>
        <div className="col-md-6 col-lg-3">
          <Card
            head2={cardContent.heading[2]}
            subhead2={cardContent.subheading[2]}
            chartIcons2={cardContent.icons[2]}
            suboffheading2={cardContent.subofheading[2]}
          ></Card>
        </div>
        <div className="col-md-6 col-lg-3">
          <Card
            head3={cardContent.heading[3]}
            subhead3={cardContent.subheading[3]}
            chartIcons3={cardContent.icons[3]}
            suboffheading3={cardContent.subofheading[3]}
          ></Card>
        </div>
      </div>

      <div className=" container row  mx-auto mt-5">
        <div className="col-md-12 col-lg-9 ">
          <div>
            <ChartTop
              heading={contenttop[0]}
              heading1={contenttopw[0]}
            ></ChartTop>
          </div>

          <Chartb />
          {/* <Graph/> */}

          <div className="row">
            <div className="col-md-4 col-lg-4">
              <ChartCard
                head1={cardBottom.headings[0]}
                subhead1={cardBottom.subheadings[0]}
                icon={cardBottom.icons[0]}
              ></ChartCard>
            </div>
            <div className="col-md-4 col-lg-4">
              <ChartCard
                head2={cardBottom.headings[1]}
                subhead2={cardBottom.subheadings[1]}
                icon1={cardBottom.icons[1]}
              ></ChartCard>
            </div>
            <div className="col-md-4 col-lg-4">
              <ChartCard
                head3={cardBottom.headings[2]}
                subhead3={cardBottom.subheadings[2]}
                icon2={cardBottom.icons[2]}
              ></ChartCard>
            </div>
          </div>
        </div>
        <div className="col-md-12 col-lg-3">
          <div className="row flex-column gy-3">
            <div className="">
              <SideCard
                head={divcardContent.headings[0]}
                subhead={divcardContent.subheading[0]}
                icon={divcardContent.icons[0]}
                Data={divcardContent.number[0]}
              >
                {" "}
              </SideCard>
            </div>
            <div className=" ">
              <SideCard
                head1={divcardContent.headings[1]}
                subhead1={divcardContent.subheading[1]}
                icon1={divcardContent.icons[1]}
                Data1={divcardContent.number[1]}
              >
                {" "}
              </SideCard>
            </div>
            <div className=" ">
              <SideCard
                head2={divcardContent.headings[2]}
                subhead2={divcardContent.subheading[2]}
                icon2={divcardContent.icons[2]}
                Data2={divcardContent.number[2]}
              >
                {" "}
              </SideCard>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-3">
        <MyTable />
      </div>
      <div className="container d-flex justify-content-between pt-3">
        <div className="">
          <Heade head={divfooter[0]} />
        </div>
        <div>
          <Heade head1={divder[0]} />
        </div>
      </div>
    </div>
  );
}

export default App;
